import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { GetTags } from "../../config/config";
export const fetchAllTags = createAsyncThunk(
  'tags/fetchAllTags',
  async (_arg: any, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(GetTags, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'
        },
      });
      return response.data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.response.data); // Return error message
    }
  }
);

const tagsSlice = createSlice({
  name: 'tags',
  initialState: {
    tags: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(fetchAllTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default tagsSlice.reducer;
